import { Dayjs } from "dayjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { inject, injectable } from "tsyringe";

import { VehicleClaim } from "src/containers/vehicle-claims/models/claim";
import { autoBind } from "src/shared/decorators/autobind";
import { VehicleClaimRepository } from "src/containers/vehicle-claims/repositories/claims/claims-repository";

type GetVehicleClaimParams = {
    claimState: string;
    initDate: Dayjs;
    endDate: Dayjs;
};

@injectable()
export class VehicleClaimService {
    constructor(
        @inject("VehicleClaimRepository")
        private repository: VehicleClaimRepository
    ) {}

    @autoBind
    getVehicleClaims(
        params: GetVehicleClaimParams
    ): Observable<VehicleClaim[]> {
        return this.repository.getVehicleClaims(params).pipe(
            map((claims) => {
                return claims.map((claim) => VehicleClaim.fromJson(claim));
            })
        );
    }
}
